(() => {
  'use strict';
  const configNode = document.querySelector('[data-pb-design-refinement]');
  let config;
  try { config = JSON.parse(configNode?.textContent || 'null'); } catch { return; }
  if (config?.theme_id !== 196759880006 || !['unpublished', 'main'].includes(config.theme_role)) return;
  if (!document.body.classList.contains('pb-colour-comparison')) return;
  const captions = {
    de: 'MONTAGE IN DEUTSCHLAND', en: 'ASSEMBLED IN GERMANY',
    fr: 'ASSEMBLÉ EN ALLEMAGNE', nl: 'GEMONTEERD IN DUITSLAND',
    es: 'MONTAJE EN ALEMANIA', it: 'ASSEMBLATO IN GERMANIA',
    pl: 'MONTAŻ W NIEMCZECH', sv: 'MONTERAD I TYSKLAND'
  };
  const newLanguages = new Set(['es', 'it', 'pl', 'sv']);
  let scheduled = false;
  const language = () => {
    let selected;
    try { selected = window.pbDraftLanguage?.(); } catch {}
    selected = String(selected || document.documentElement.lang || 'de').toLowerCase().split('-')[0];
    if (newLanguages.has(selected) && new URL(location.href).searchParams.get('pb_draft_lang') !== selected) return null;
    return captions[selected] ? selected : null;
  };
  const update = () => {
    scheduled = false;
    const lang = language();
    const existing = document.querySelectorAll('[data-pb-assembly-caption]');
    if (!lang) { existing.forEach(node => node.remove()); return; }
    for (const marker of document.querySelectorAll('.pb-home-series article [data-pb-i18n="pb_design.series_cards.lumo"], .pb-bundle-series__copy [data-pb-i18n="pb_design.series_cards.lumo"]')) {
      const paragraph = marker.closest('p');
      const card = marker.closest('.pb-home-series article, .pb-bundle-series__copy');
      if (!paragraph || !card || paragraph.parentElement !== card || card.querySelectorAll('[data-pb-i18n="pb_design.series_cards.lumo"]').length !== 1) continue;
      const notice = card.querySelector('[data-pb-i18n="pb_design.home.lumo_notice"], [data-pb-i18n="pb_design.home.lumo_notice_and"]')?.closest('p');
      if (!notice || notice.parentElement !== card || paragraph.nextElementSibling !== notice && !paragraph.nextElementSibling?.hasAttribute('data-pb-assembly-caption')) continue;
      let caption = card.querySelector('[data-pb-assembly-caption]');
      if (!caption) {
        caption = document.createElement('p');
        caption.className = 'pb-assembly-caption';
        caption.setAttribute('data-pb-assembly-caption', '');
        caption.setAttribute('data-wg-notranslate', '');
        paragraph.after(caption);
      }
      if (caption.textContent !== captions[lang]) caption.textContent = captions[lang];
      if (caption.lang !== lang) caption.lang = lang;
      if (card.closest('.pb-home-series') && !notice.classList.contains('pb-home-series__delivery')) notice.classList.add('pb-home-series__delivery');
    }
  };
  const schedule = () => { if (!scheduled) { scheduled = true; requestAnimationFrame(update); } };
  const observer = new MutationObserver(schedule);
  observer.observe(document.body, { subtree: true, childList: true, characterData: true });
  new MutationObserver(schedule).observe(document.documentElement, { attributes: true, attributeFilter: ['lang'] });
  document.addEventListener('change', schedule);
  window.addEventListener('popstate', schedule);
  document.addEventListener('shopify:section:load', schedule);
  try { window.Weglot?.on?.('languageChanged', schedule); } catch {}
  update();
})();

(() => {
  'use strict';
  let config;
  try { config = JSON.parse(document.querySelector('[data-pb-design-refinement]')?.textContent || 'null'); } catch { return; }
  if (config?.theme_id !== 196759880006 || !['unpublished', 'main'].includes(config.theme_role)) return;
  const savedScroll = new WeakMap();
  let handledEscape = false;
  const sizeDesktopPanels = () => {
    const reserve = Number.parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--pb-preview-offset')) || 64;
    for (const details of document.querySelectorAll('.pb-nav--desktop > .pb-bike-nav-root[open]')) {
      const panel = details.querySelector(':scope > .pb-nav__panel');
      if (panel) panel.style.maxHeight = Math.max(120, innerHeight - panel.getBoundingClientRect().top - reserve - 12) + 'px';
    }
  };
  const scrollArea = details => details.closest('.drawer__scrollable');
  const goBack = details => {
    if (!details) return;
    for (const child of details.querySelectorAll('details[data-pb-nav-level][open]')) child.open = false;
    details.open = false;
    details.querySelector(':scope > summary')?.focus({ preventScroll: true });
    const area = scrollArea(details);
    if (area) area.scrollTop = savedScroll.get(details) || 0;
  };
  const initialize = () => {
    for (const nav of document.querySelectorAll('.pb-nav--mobile')) nav.classList.add('pb-nav-stepped');
  };
  document.addEventListener('toggle', event => {
    const details = event.target;
    if (!(details instanceof HTMLDetailsElement) || !details.hasAttribute('data-pb-nav-level') || !details.closest('.pb-nav')) return;
    if (!details.open) return;
    sizeDesktopPanels();
    for (const sibling of details.parentElement.children) {
      if (sibling !== details && sibling instanceof HTMLDetailsElement && sibling.hasAttribute('data-pb-nav-level')) sibling.open = false;
    }
    if (details.closest('.pb-nav--mobile') && matchMedia('(max-width: 768px)').matches) {
      const area = scrollArea(details);
      if (area) { savedScroll.set(details, area.scrollTop); area.scrollTop = 0; }
      details.querySelector(':scope > .pb-nav-level-panel > [data-pb-nav-back]')?.focus({ preventScroll: true });
    }
  }, true);
  document.addEventListener('click', event => {
    const back = event.target.closest?.('[data-pb-nav-back]');
    if (back) goBack(back.closest('details[data-pb-nav-level]'));
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const nav = document.querySelector('#NavDrawer.drawer--is-open .pb-nav--mobile, #NavDrawer.is-open .pb-nav--mobile') || event.target.closest?.('.pb-nav--mobile');
    if (!nav) return;
    const levels = nav.querySelectorAll('details[data-pb-nav-level][open]');
    if (!levels.length) return;
    handledEscape = true;
    event.preventDefault(); event.stopImmediatePropagation();
    goBack(levels[levels.length - 1]);
  }, true);
  document.addEventListener('keyup', event => {
    if (event.key === 'Escape' && handledEscape) {
      handledEscape = false;
      event.preventDefault(); event.stopImmediatePropagation();
    }
  }, true);
  window.addEventListener('resize', sizeDesktopPanels);
  document.addEventListener('shopify:section:load', initialize);
  initialize();
})();
